export default "__VITE_ASSET__f7f08c0d__"